import { render } from "./AddFoodDialog.vue?vue&type=template&id=09d82b15&scoped=true&ts=true"
import script from "./AddFoodDialog.vue?vue&type=script&lang=ts"
export * from "./AddFoodDialog.vue?vue&type=script&lang=ts"

import "./AddFoodDialog.vue?vue&type=style&index=0&id=09d82b15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d82b15"]])

export default __exports__